$(document).ready(function() {
  $(".navbar-toggler").on("click", function() {
    $("#navbarSupportedContent").toggleClass("mobile-navbar-visible")
    $("#navbarRegistrationFlow").toggleClass("mobile-navbar-visible")
  })
})
